module.exports = __webpack_public_path__ + "img/surprised.84966ac5.png";